import React from 'react'
import { useFormContext } from 'react-hook-form'
import TextField from '@material-ui/core/TextField'
import Box from '@material-ui/core/Box'
import { useStyles } from '../styles'

const ExternalRegistrationUrl = () => {
  const { register, errors } = useFormContext()
  const classes = useStyles()

  return (
    <Box className={classes.fieldGroup}>
      <TextField
        label="External registration URL"
        placeholder="https://www.example.com"
        name="externalRegistrationUrl"
        inputRef={register}
        error={!!errors?.externalRegistrationUrl}
        helperText={errors?.externalRegistrationUrl?.message}
        variant="outlined"
        fullWidth
        className={classes.fieldInput}
      />
    </Box>
  )
}

export default ExternalRegistrationUrl
